import { render, staticRenderFns } from "./BlockFees.vue?vue&type=template&id=fff5f782&"
import script from "./BlockFees.vue?vue&type=script&lang=js&"
export * from "./BlockFees.vue?vue&type=script&lang=js&"
import style0 from "./BlockFees.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports